import { type ChainedCommands, Editor } from '@tiptap/core'
import { TmTiptapEditor } from '@/services/forms/tmTiptap/tmTiptapEditor'
import { TmTiptapEditorError } from '@/core/error/tmTiptapEditorError'
import { isRecordUnknown } from '@/utils/typeGuards'
import { isHtmlElement } from '@/utils/string/html/html'

export const isTmTiptapEditor = (value: unknown): value is TmTiptapEditor => {
  return value instanceof TmTiptapEditor
}

export const verifyTmTiptapEditor = (value: unknown): TmTiptapEditor => {
  if (!isTmTiptapEditor(value)) {
    throw new TmTiptapEditorError('Value should be an instance of TmTiptapEditor')
  }
  return value
}
export const getChainWithPossibleFocus = (
  editorOrChain: TmTiptapEditor | Editor | ChainedCommands,
  withFocus: boolean,
): ChainedCommands => {
  const chain = editorOrChain instanceof Editor ? editorOrChain.chain() : editorOrChain
  return withFocus ? chain.focus(undefined, { scrollIntoView: false }) : chain
}

export const getEditorRootParent = (editorParam: unknown): HTMLDivElement | null => {
  const editor = verifyTmTiptapEditor(editorParam)
  const editorRoot = editor.view.dom

  if (!editorRoot) {
    return null
  }

  if (
    !isHtmlElement(editorRoot) ||
    !isHtmlElement(editorRoot.parentElement) ||
    editorRoot.parentElement.tagName !== 'DIV'
  ) {
    throw new TmTiptapEditorError(
      `Expected editor root parent element to be a HTMLDivElement, got ${Object.prototype.toString.call(
        editorRoot.parentElement,
      )}`,
    )
  }
  return editorRoot.parentElement as HTMLDivElement
}

export const getEditorBody = (editorParam: unknown): HTMLBodyElement | null => {
  const editor = verifyTmTiptapEditor(editorParam)
  const editorRoot = editor.view.root as ShadowRoot

  return editorRoot.querySelector('body')
}

export const getStorage = <T extends Record<string, unknown>>(extensionContext: unknown): T => {
  if (!isRecordUnknown(extensionContext) || !('storage' in extensionContext)) {
    throw new TmTiptapEditorError('No storage found in extension context')
  }
  return extensionContext.storage as T
}
